import styled from 'styled-components';
import {colorTheme} from '../../../ui-toolkit/mixin/colorTheme';

export const scrollBar = ({scrollbarBorder, scrollbarBackground, scrollbarThumb, scrollbarThumbHover}) => `
    --scrollbar-height: 5px;
    --scrollbar-padding: 5px;
    --scrollbar-width: calc((var(--scrollbar-padding) * 2) + var(--scrollbar-height));
    &::-webkit-scrollbar {
        height: calc( var(--scrollbar-width) - 2px);
        width: var(--scrollbar-width);
    }

    &::-webkit-scrollbar-track,
    &::-webkit-scrollbar-thumb {
        border: 4px solid ${scrollbarBorder || 'var(--scroll-bar-background)'};
        border-radius: 50px;
        background-clip: padding-box;
    }

    &::-webkit-scrollbar-track { 
           background-color: ${scrollbarBackground || 'var(--scroll-bar-border)'};
    }

    &::-webkit-scrollbar-thumb {
        background: ${scrollbarThumb || 'var(--scroll-bar-thumb)'};
        border-radius: 50px;
        &:hover {
            border: 2px solid ${scrollbarThumbHover || 'var(--scroll-bar-thumb-hover)'};
            cursor: pointer;
        }
    }

    &::-webkit-scrollbar-corner {
        /*
        background-image: url(resources/corner.png);
        background-repeat: no-repeat;
        */
        background-color: var(--app-background);
    }
`;

export const ScrollBar = styled.div`
    ${colorTheme({
        //== scroll ===
        '--scroll-bar-background ': {dark: 'var(--black-14)                          ', light: 'var(--purple-00)'},
        '--scroll-bar-border     ': {
            dark: 'var(--scroll-bar-background )   ',
            light: 'var(--scroll-bar-background )',
        },
        '--scroll-bar-thumb      ': {
            dark: 'var(--black-03)                             ',
            light: 'var(--white-00)',
        },
        '--scroll-bar-thumb-hover': {
            dark: 'var(--black-03)                            ',
            light: 'var(--scroll-bar-background )',
        },

        // // === Mozilla mod === // //
        '--scroll-bar-background-moz      ': {
            dark: 'var(--black-03)                              ',
            light: 'var(--white-00)',
        },
        '--scroll-bar-thumb-moz ': {dark: 'var(--black-14)                          ', light: 'var(--purple-00)'},
    })};
    ${scrollBar};
`;
